import { translations } from '@aws-amplify/ui'
import { I18n, Amplify } from 'aws-amplify'
import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ConfigProvider } from 'antd'
import {
	onlineManager,
	QueryClient,
	QueryClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import Routes from './App.routes'
import { persistor, store } from './states/store'
import GlobalStyle from './styles/global'

store.subscribe(() => {
	const state = store.getState()
	if (state.session?.primaryColor) {
		ConfigProvider.config({
			theme: {
				primaryColor: state.session.primaryColor,
			},
		})
	}
})

Amplify.configure({
	Auth: {
		region: process.env.REACT_APP_AWS_REGION,
		userPoolId: process.env.REACT_APP_AWS_USER_POOL,
		userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
		identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
	},
	Storage: {
		AWSS3: {
			bucket: process.env.REACT_APP_AWS_DOCUMENT_BUCKET,
			region: process.env.REACT_APP_AWS_REGION,
			isObjectLockEnabled: true, //OPTIONAl - Object Lock parameter
			customPrefix: {
				public: 'uploads/',
			},
		},
	},
})

I18n.putVocabularies(translations)
I18n.putVocabularies({
	pt: {
		Email: 'Email',
		Name: 'Nome',
		'Email or Phone Number': 'Email ou número de telefone',
		'We Emailed You': 'Confirmação de email',
		'We Sent A Code': 'Confirmação de email',
		Confirm: 'Confirmar',

		'Invalid verification code provided, please try again.':
			'Código de verificação inválido. Por favor tente novamente.',

		'Your code is on the way. To log in, enter the code we sent you. It may take a minute to arrive.':
			'Seu código está a caminho. Para fazer o login, digite o código que enviamos a você. Pode demorar um minuto para chegar.',
	},
})

onlineManager.setOnline(true)
const queryClient = new QueryClient()

const App = () => {
	return (
		<Provider store={store}>
			<DndProvider backend={HTML5Backend}>
				<PersistGate persistor={persistor}>
					<QueryClientProvider client={queryClient}>
						<GlobalStyle />
						<Routes />
						<ReactQueryDevtools initialIsOpen={false} />
					</QueryClientProvider>
				</PersistGate>
			</DndProvider>
		</Provider>
	)
}

export default App
